import React from 'react';
import {injectIntl} from 'react-intl';
import messages from '../../../../res/translations/messages';
import FormGroupField from '../FormGroupField';

export const PinpointParameters = ({provider}) => {
    return (
        <div className="col">
            <FormGroupField type="text"
                id="uef-organization-sendProvider-parameters-applicationId"
                name="parameters.applicationId"
                label={messages.admin.organization.sendProviders[provider].parameters.applicationId} />
        </div>
    );
};

export default injectIntl(PinpointParameters);
